"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    forms: {
        contact: {
            selectOptionsSubject: [
                { displayName: 'form.type.subject.option.order', value: 'order' },
                { displayName: 'form.type.subject.option.datasecurity', value: 'datasecurity' },
                { displayName: 'form.type.subject.option.web', value: 'web' },
                { displayName: 'form.type.subject.option.account', value: 'account' },
                { displayName: 'form.type.subject.option.personalData', value: 'personalData' },
                { displayName: 'form.type.subject.option.praemie', value: 'praemie' },
                { displayName: 'form.type.subject.option.product', value: 'product' },
                {
                    displayName: 'form.type.subject.option.complaint.textileshoes',
                    value: 'complaint_textile-shoes',
                },
                {
                    displayName: 'form.type.subject.option.complaint.hometextile',
                    value: 'complaint_hometextile',
                },
                {
                    displayName: 'form.type.subject.option.complaint.furtherassortments',
                    value: 'complaint',
                },
                { displayName: 'form.type.subject.option.complaint.returnsprocessing', value: 'return' },
            ],
        },
    },
};
exports.default = config;
//# sourceMappingURL=baurde.js.map